import { render, staticRenderFns } from "./StarFilled.vue?vue&type=template&id=375b6d54&"
import script from "./StarFilled.vue?vue&type=script&lang=ts&"
export * from "./StarFilled.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports